  <template>
    <div class="custom-loader">
      <img src="images/logok_lama_1.png" alt="Loading..." /><br /><br />
    </div>
  </template>
  
  <style>
    .custom-loader {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
    }
  
    .custom-loader img {
      width: 100px;
      height: 100px;
      animation: zoom-in-zoom-out 1s ease infinite;
    }
  
    @keyframes zoom-in-zoom-out {
        0% {
            transform: scale(1, 1);
        }
        50% {
            transform: scale(1.4, 1.4);
        }
        100% {
            transform: scale(1, 1);
        }
    }
  </style>
  